export const SIGNAL_TYPES = {
    STRAIGHT: 'straight',          // Ajoneuvo-opastin 3ø200 ja tunnus
    LEFT: 'left',                  // Ajoneuvo-opastin 3ø200 nuolikuvioin, vasen
    RIGHT: 'right',                // Ajoneuvo-opastin 3ø200 nuolikuvioin, oikea
    TRAM: 'tram',                  // Raitiovaunuopastin 3ø200
    PEDESTRIAN: 'pedestrian',      // Jalankulkijaopastin 2ø200 ääniopastimin
    LEFT_2: 'left2',               // Ajoneuvo-opastin 2ø200 nuolikuvioin, vasen
    RIGHT_2: 'right2',             // Ajoneuvo-opastin 2ø200 nuolikuvioin, oikea
    LEFT_1: 'left1',               // Ajoneuvo-opastin 1ø200 nuolikuvioin, vasen
    RIGHT_1: 'right1',             // Ajoneuvo-opastin 1ø200 nuolikuvioin, oikea
    RV1: 'rv1',                    // Raitiovaunuopastin RV1
    RV2: 'rv2',                    // Raitiovaunuopastin RV2
    STRAIGHT_RV: 'straight_rv'     // Joukkoliikenneopastin
};

export const MANEUVERS = {
    STRAIGHT: 'STRAIGHT',
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
    U_TURN: 'U-TURN'
};

/**
 * Checks if a signal type string supports a specific maneuver.
 * Based on types defined in intersection_gui.py
 * 
 * @param {string} type - The signal type string from topology (e.g. 'straight', 'left', 'right2')
 * @param {string} maneuver - The route maneuver ('STRAIGHT', 'LEFT', 'RIGHT')
 * @returns {boolean}
 */
export const supportsManeuver = (type, maneuver) => {
    if (!type) return false;
    const t = type.toLowerCase();

    // Map maneuvers to supported signal types
    switch (maneuver) {
        case MANEUVERS.STRAIGHT:
            return t === SIGNAL_TYPES.STRAIGHT || t === SIGNAL_TYPES.STRAIGHT_RV;

        case MANEUVERS.LEFT:
        case MANEUVERS.U_TURN: // Left turn signals typically support U-turns (unless prohibited, but signal itself allows)
            return t === SIGNAL_TYPES.LEFT ||
                t === SIGNAL_TYPES.LEFT_1 ||
                t === SIGNAL_TYPES.LEFT_2;

        case MANEUVERS.RIGHT:
            return t === SIGNAL_TYPES.RIGHT ||
                t === SIGNAL_TYPES.RIGHT_1 ||
                t === SIGNAL_TYPES.RIGHT_2;

        default:
            return false;
    }
};

/**
 * Checks if a signal type string explicitly opposes a specific maneuver.
 * For example, a left-turn signal opposes a right-turn maneuver.
 * 
 * @param {string} type - The signal type string
 * @param {string} maneuver - The route maneuver
 * @returns {boolean}
 */
export const opposesManeuver = (type, maneuver) => {
    if (!type) return false;
    const t = type.toLowerCase();

    const isLeftSig = t === SIGNAL_TYPES.LEFT || t === SIGNAL_TYPES.LEFT_1 || t === SIGNAL_TYPES.LEFT_2;
    const isRightSig = t === SIGNAL_TYPES.RIGHT || t === SIGNAL_TYPES.RIGHT_1 || t === SIGNAL_TYPES.RIGHT_2;

    if (maneuver === MANEUVERS.RIGHT && isLeftSig) return true;
    if ((maneuver === MANEUVERS.LEFT || maneuver === MANEUVERS.U_TURN) && isRightSig) return true;

    return false;
};

export const MAIN_STREET_SIGNAL_DIRECTIONS = ['A', 'B'];

export const isMainStreetSignal = (signal) => {
    return signal && signal.name && MAIN_STREET_SIGNAL_DIRECTIONS.includes(signal.name);
};

export const isPedestrianSignal = (signal) => {
    return signal && signal.name && signal.name.indexOf('_') === 0;
};

export const isTrolleyPedestrianSignal = (signal) => {
    return signal && signal.name && signal.name.indexOf('VAROVA') === 0;
};

export const isPrioritySignal = (signal) => {
    return signal && signal.name && signal.name.includes('PRIO'); // RV1PRIO, PRIO_RV1
};

export const isTrolleySignal = (signal) => {
    return signal && signal.name && (signal.name.indexOf('RV') === 0 && !isPrioritySignal(signal));
};

export const isDriverSignal = (signal) => {
    return !isPedestrianSignal(signal) &&
        !isTrolleyPedestrianSignal(signal) &&
        !isTrolleySignal(signal) &&
        !isPrioritySignal(signal);
};

export const isVehicleSignal = (type) => {
    if (!type) return false;
    const t = type.toLowerCase();
    // straight_rv IS a vehicle signal, despite having 'rv' in the name
    if (t === SIGNAL_TYPES.STRAIGHT_RV) return true;

    return !t.includes(SIGNAL_TYPES.PEDESTRIAN) && !t.includes(SIGNAL_TYPES.TRAM) && !t.includes('rv');
};
